var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, _vm._l(Object.keys(_vm.results), function (item) {
    return _c('card', {
      key: item,
      attrs: {
        "title": `${item} (${_vm.data[item] && _vm.data[item].length || 0} results)`
      }
    }, [_c('Table', {
      attrs: {
        "items": _vm.data[item] || [],
        "columns": _vm.results[item] && _vm.results[item].columns || [],
        "links": _vm.results[item] && _vm.results[item].links,
        "filterProp": _vm.results[item] && _vm.results[item].filterProp
      }
    })], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }